import { Trans } from '@lingui/macro'
import {
  ButtonBase,
  Card,
  Collapse,
  Divider,
  Grid,
  Icon,
  Slide,
  Typography
} from '@mui/material'
import { withStyles } from '@mui/styles'
import { Component } from 'react'
import { Draggable, Droppable } from 'react-beautiful-dnd'
import ActionPlanBoardCard from './ActionPlanBoardCard'

class ActionPlanColumn extends Component {
  state = {
    shouldOpenTitleEditor: false,
    shouldOpenAddCard: false,
    minimized: false,
    cardTitleText: '',
    columnTitleText: ''
  }

  componentDidMount () {
    if (this.props.column.title === 'On hold') {
      this.setState({ minimized: true })
    }
  }

  handleChange = event => {
    if (event.key === 'Enter' && !event.shiftKey) {
      this.props.handleAddNewCard(
        this.state.cardTitleText,
        this.props.columnIndex
      )
      this.openTitleEditor(false)
      this.openAddCard(false)
    } else this.setState({ [event.target.name]: event.target.value })
  }

  openTitleEditor = value => {
    this.setState({ shouldOpenTitleEditor: value })
  }

  openAddCard = value => {
    this.setState({ shouldOpenAddCard: value })
  }

  render () {
    const { minimized } = this.state
    const {
      cardActions,
      columns,
      column,
      deleting,
      columnIndex,
      minimizedFull,
      handleColumnMinimize
    } = this.props

    return (
      <Card
        className='action-plan-column'
        style={{
          maxWidth: minimized && !minimizedFull ? '55px' : '100%',
          borderLeft: columnIndex === 0 ? '1px solid rgba(0, 0, 0, 0.25)' : null,
          borderRight: '1px solid rgba(0, 0, 0, 0.25)',
          borderBottom: '1px solid rgba(0, 0, 0, 0.25)',
          borderTop: '1px solid rgba(0, 0, 0, 0.25)'
        }}
      >
        <ButtonBase
          onClick={() => {
            handleColumnMinimize(!minimized, columnIndex)
            this.setState({ minimized: !minimized })
          }}
          style={{ padding: 0 }}
        >
          <Grid
            container
            justifyContent='center'
            alignItems='center'
            style={{ height: '70px' }}
          >
            {!minimized
              ? (
                <Typography
                  className='action-plan-header'
                >
                  <Trans id={column.title} />
                </Typography>
                )
              : (
                <Icon>expand_more</Icon>
                )}
          </Grid>
        </ButtonBase>
        <Divider />
        <div
          style={{ height: '100%', display: 'flex', flexDirection: 'column', paddingTop: 12 }}
        >
          <Droppable
            droppableId={column.title}
            direction='vertical'
            type='card'
            isDropDisabled={this.state.minimized}
          >
            {(provided, snapshot) => (
              <div ref={provided.innerRef} style={{ flexGrow: 1 }}>
                <Collapse in={!this.state.minimized}>
                  {!minimized &&
                    column.actions.map((card, index) => (
                      <Draggable
                        key={card.id}
                        draggableId={'draggableId' + card.id}
                        index={index}
                        type='card'
                      >
                        {(provided, snapshot) => (
                          <Card
                            onClick={() => {
                              cardActions.openDialog({
                                ...card,
                                columnIndex: column.index,
                                cardIndex: index
                              })
                            }}
                            className='list-column__card action-plan-action-card'
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={provided.draggableProps.style}
                          >
                            <ActionPlanBoardCard
                              deleting={deleting}
                              columns={columns}
                              card={card}
                              index={index}
                              cardActions={cardActions}
                              column={column}
                            />
                          </Card>
                        )}
                      </Draggable>
                    ))}

                  {provided.placeholder}
                </Collapse>

                {minimized && (
                  <Slide in={minimized} direction='up'>
                    <div style={{ paddingTop: minimizedFull ? 65 : 50 }}>
                      <h4
                        className='nowrap'
                        style={{
                          textAlign: 'center',
                          transform: 'rotate(90deg)',
                          marginBottom: 0
                        }}
                      >
                        <Trans id={column.title} /> {column.actions.length}
                      </h4>
                    </div>
                  </Slide>
                )}
              </div>
            )}
          </Droppable>
        </div>
      </Card>
    )
  }
}

export default withStyles({}, { withTheme: true })(ActionPlanColumn)
